module.exports = __webpack_public_path__ + "static/img/caboArduinoNano-1.c35a926.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/caboArduinoNano-1.svg
// module id = z4uj
// module chunks = 0